module.exports = __webpack_public_path__ + "static/media/trophy-1.7d2262e4.svg";